import content from './content/texts.js';

export default {
  content,
  list: {
    header: {
      notes: 'Header in list parts pange',
      message: 'Spare parts catalogues',
    },
    relatedCatalogs: {
      header: {
        notes: 'Header in section listing applicable spare part catalogs',
        message: 'Spare parts catalogues',
      },
    },
    empty: {
      text: {
        notes: 'Text of empty state message when listing parts',
        message: 'No content to show, please modify your selection.',
      },
    },
    partsTable: {
      header: {
        notes: 'Little i helptext for parts catalog datagrid',
        message: 'Parts for all catalogues shown above',
      },
    },
  },
  category: {
    equipmentCategory: {
      notes: 'Name of equipment category in category tree',
      message: 'Equipment category',
    },
    equipmentFamily: {
      notes: 'Name of equipment family in category tree',
      message: 'Equipment family',
    },
    equipmentModel: {
      notes: 'Name of equipment model in category tree',
      message: 'Equipment model',
    },
  },
};
